module.exports = __webpack_public_path__ + "static/media/moduleSet_i5o4.067e8df9.jpg";